// extracted by mini-css-extract-plugin
module.exports = {"reactPlayer":"match-modal_component_reactPlayer__jI86Y","legacyModalBody":"match-modal_component_legacyModalBody__8CTjY","buttonWrap":"match-modal_component_buttonWrap__7ICz7"};